import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { api } from '../lib/api';

type Me = { id: string; email: string; role: string } | null;

let cachedMe: Me = undefined as unknown as Me;

export default function AuthGate({ children }: { children: React.ReactNode }) {
  const [me, setMe] = useState<Me | undefined>(cachedMe === undefined ? undefined : cachedMe);
  const location = useLocation();

  useEffect(() => {
    if (me !== undefined) return;
    api.get('/auth/me')
      .then((u) => { cachedMe = u as Me; setMe(u as Me); })
      .catch(() => { cachedMe = null; setMe(null); });
  }, [me]);

  if (me === undefined) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100vh', color: 'var(--text-muted)' }}>
        Loading…
      </div>
    );
  }
  if (me === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

export function clearAuthCache() { cachedMe = undefined as unknown as Me; }
